export default "6970e301820b235e.svg"